import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ControlSystemDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-control-system-dialog',
  templateUrl: './control-system-dialog.component.html',
  styleUrls: ['./control-system-dialog.component.scss'],
})
export class ControlSystemDialogComponent implements OnInit {
  @Output()
  submit = new EventEmitter<ControlSystemDto>();

  firstSubmit = false;

  form?: ReturnType<typeof this.initForm>;

  ngOnInit() {
    this.form = this.initForm();
  }

  initForm() {
    return new FormGroup({
      controlSystem: new FormControl(undefined, Validators.required),
    });
  }

  submitControlSystem() {
    this.firstSubmit = true;

    if (this.form && this.form.valid) {
      return {
        ...this.form.value,
      };
    }
    throw new Error('Form is not valid');
  }

  hasError(controlName: string): boolean {
    const control = this.form?.get(controlName);
    return !!control?.errors;
  }
}
